import { Box, Container, Typography, Paper, Alert } from '@mui/material';

export default function AITermsPage() {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="md">
        <Paper sx={{ p: 5, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>AI 서비스 이용약관</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>최종 수정일: 2026년 2월 10일 | AI기본법 준수</Typography>

          <Alert severity="info" sx={{ mb: 3 }}>
            본 약관은 인공지능 기본법(AI기본법)에 따라 작성되었으며, AI 서비스 이용 시 반드시 숙지하고 동의해야 합니다.
          </Alert>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제1조 (목적 및 적용 범위)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">본 약관은 주식회사 케이지네트워크(이하 "회사")가 제공하는 인공지능(AI) 기반 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</Typography></li>
            <li><Typography variant="body1">본 약관은 AI 채팅, AI 문서 분석, AI 기반 추천 등 회사가 제공하는 모든 AI 서비스에 적용됩니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제2조 (AI 서비스의 정의)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">"AI 서비스"란 인공지능 기술을 활용하여 텍스트 생성, 문서 분석, 대화 응답 등을 제공하는 서비스를 말합니다.</Typography></li>
            <li><Typography variant="body1">"AI 생성 콘텐츠"란 AI 모델이 자동으로 생성한 텍스트, 이미지, 분석 결과 등을 말합니다.</Typography></li>
            <li><Typography variant="body1">"프롬프트"란 이용자가 AI 서비스에 입력하는 질문, 명령, 요청 등을 말합니다.</Typography></li>
            <li><Typography variant="body1">"임베딩"이란 문서를 AI가 이해할 수 있는 벡터 형태로 변환하는 과정을 말합니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제3조 (AI 서비스 투명성 고지) - AI기본법 제15조</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">회사는 이용자에게 AI 서비스를 제공하고 있음을 명확히 고지합니다.</Typography></li>
            <li><Typography variant="body1">모든 AI 생성 콘텐츠에는 "🤖 AI 생성" 표시가 자동으로 부착됩니다.</Typography></li>
            <li><Typography variant="body1">회사가 사용하는 AI 모델: 대화 모델(Gemma 3), 임베딩 모델(Nomic Embed Text), 벡터 DB(ChromaDB)</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제4조 (AI 서비스의 한계 및 주의사항)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">정확성 한계: AI는 잘못된 정보, 부정확한 답변을 생성할 수 있습니다.</Typography></li>
            <li><Typography variant="body1">환각(Hallucination): AI는 존재하지 않는 정보를 사실처럼 생성할 수 있습니다.</Typography></li>
            <li><Typography variant="body1">편향성: AI는 학습 데이터의 편향을 반영할 수 있습니다.</Typography></li>
            <li><Typography variant="body1">시의성: AI의 지식은 특정 시점까지의 데이터에 기반합니다.</Typography></li>
            <li><Typography variant="body1">맥락 이해 한계: AI는 복잡한 맥락이나 뉘앙스를 완벽히 이해하지 못할 수 있습니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제5조 (유해 콘텐츠 방지) - AI기본법 제47조</Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>다음과 같은 콘텐츠는 자동으로 차단됩니다:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">폭력적, 혐오적, 차별적 표현</Typography></li>
            <li><Typography variant="body1">불법적 행위를 조장하는 내용</Typography></li>
            <li><Typography variant="body1">성적으로 노골적인 콘텐츠</Typography></li>
            <li><Typography variant="body1">개인정보가 포함된 콘텐츠</Typography></li>
            <li><Typography variant="body1">저작권을 침해하는 콘텐츠</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제6조 (개인정보 보호 및 데이터 처리)</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">즉시 삭제 정책: 업로드된 파일은 AI 처리(임베딩) 후 즉시 삭제됩니다.</Typography></li>
            <li><Typography variant="body1">임베딩만 보관: 원본 파일은 삭제되고, 벡터 형태의 임베딩만 보관됩니다.</Typography></li>
            <li><Typography variant="body1">개인정보 필터링: 주민번호, 카드번호 등 개인정보는 자동으로 감지되어 차단됩니다.</Typography></li>
            <li><Typography variant="body1">대화 기록: AI 대화 내용은 서비스 개선 목적으로 익명화하여 보관할 수 있습니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제7조 (이용자의 권리와 의무)</Typography>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>이용자의 권리:</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">AI 서비스 이용에 대한 충분한 설명을 받을 권리</Typography></li>
            <li><Typography variant="body1">AI 생성 콘텐츠의 한계를 고지받을 권리</Typography></li>
            <li><Typography variant="body1">개인정보 처리에 대한 투명한 정보를 제공받을 권리</Typography></li>
            <li><Typography variant="body1">AI 서비스 이용을 거부하거나 중단할 권리</Typography></li>
          </Box>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>이용자의 의무:</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">AI 생성 콘텐츠를 맹신하지 않고 비판적으로 검토할 의무</Typography></li>
            <li><Typography variant="body1">중요한 결정에는 AI 생성 콘텐츠만 의존하지 않을 의무</Typography></li>
            <li><Typography variant="body1">AI 서비스를 악용하여 유해 콘텐츠를 생성하지 않을 의무</Typography></li>
            <li><Typography variant="body1">타인의 권리를 침해하는 방식으로 AI 서비스를 사용하지 않을 의무</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제8조 (AI 생성 콘텐츠의 저작권)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">AI 생성 콘텐츠의 저작권은 현행 저작권법에 따라 판단됩니다.</Typography></li>
            <li><Typography variant="body1">이용자는 AI 생성 콘텐츠를 상업적으로 이용하기 전에 법적 검토를 수행해야 합니다.</Typography></li>
            <li><Typography variant="body1">회사는 AI 생성 콘텐츠의 저작권 문제에 대해 책임을 지지 않습니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제9조 (책임의 제한)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">회사는 AI 생성 콘텐츠의 정확성, 완전성, 신뢰성, 적법성을 보증하지 않습니다.</Typography></li>
            <li><Typography variant="body1">이용자가 AI 생성 콘텐츠를 신뢰하여 발생한 손해에 대해 회사는 책임을 지지 않습니다.</Typography></li>
            <li><Typography variant="body1">이용자는 AI 생성 콘텐츠를 참고용으로만 사용하며, 중요한 결정에는 전문가의 조언을 구해야 합니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제11조 (분쟁 해결 및 신고)</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">이메일: kz4network@gmail.com</Typography></li>
            <li><Typography variant="body1">전화: 032-351-9117</Typography></li>
            <li><Typography variant="body1">AI 관련 분쟁: 과학기술정보통신부 인공지능안전신뢰정책과(044-202-6292)</Typography></li>
          </Box>

          <Alert severity="warning" sx={{ mt: 3 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>AI 서비스 이용 시 유의사항</Typography>
            <Typography variant="body2">• AI 생성 콘텐츠는 참고용으로만 사용하세요</Typography>
            <Typography variant="body2">• 중요한 결정에는 전문가의 조언을 구하세요</Typography>
            <Typography variant="body2">• 개인정보나 기밀 정보를 입력하지 마세요</Typography>
            <Typography variant="body2">• AI의 한계를 이해하고 비판적으로 검토하세요</Typography>
          </Alert>

          <Typography variant="body1" sx={{ mt: 3 }}>
            <strong>부칙:</strong> 본 약관은 2026년 2월 10일부터 시행됩니다. 본 약관은 인공지능 기본법(2026년 1월 22일 시행)을 준수하여 작성되었습니다.
          </Typography>

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" color="text.secondary">주식회사 케이지네트워크 | 대표이사: 김대경</Typography>
            <Typography variant="body2" color="text.secondary">경기도 부천시 은성로32 비1층(소사본동)</Typography>
            <Typography variant="body2" color="text.secondary">사업자등록번호: 747-87-02879 | 통신판매업 신고번호: 제 2024-부천소사-0543 호</Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
